export const engagementCanvasVersionsWorkflowIdAppGroupId =
  "/engagement/:app_group_id/canvas/:workflow_id/versions";
